import { type FunctionComponent } from 'react';

import { Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const RadioButton: FunctionComponent<Props> = ({
    className = '',
    isSelected,
    onClick,
    testId = TEST_ID
}) => {
    const selectedClass = isSelected ? styles.selected : '';

    return (
        <Wrapper className={`${styles.radioButton} ${className}`} onClick={onClick} testId={testId}>
            <div className={selectedClass} />
        </Wrapper>
    );
};

export default RadioButton;
